import { render, staticRenderFns } from "./RePresentation.vue?vue&type=template&id=03c27c98&scoped=true"
import script from "./RePresentation.vue?vue&type=script&lang=js"
export * from "./RePresentation.vue?vue&type=script&lang=js"
import style0 from "./RePresentation.vue?vue&type=style&index=0&id=03c27c98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c27c98",
  null
  
)

export default component.exports